import type { FormikTouched } from 'formik';
import type * as React from 'react';
import { useRef } from 'react';
import ButtonComponent from '../../../../components/UI/Button/Button.component';
import { BUTTON_LABELS } from '../../../../constants/button-labels.constants';
import { GLOBAL_CONSTANTS } from '../../../../constants/globals';
import type {
  LandingPageEnum,
  ThemeEnum,
} from '../../../../interfaces/user.interface';
import '../../user-profile-avatar.scss';

interface ChangeAvatarProps {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  touched: FormikTouched<{
    landingPage: LandingPageEnum;
    theme: ThemeEnum;
    avatar: string | undefined;
    id?: string;
    userId?: { _id: string };
    preferencesId?: { _id: string };
  }>;
  isValid: boolean;
  file: File | null;
  uploading: boolean;
  handleUpload: () => Promise<undefined | string>;
  handleCancelChangeAvatar: () => void;
  isChangingAvatar: boolean;
}

const ChangeAvatar = (props: ChangeAvatarProps) => {
  const {
    handleFileChange,
    touched,
    isValid,
    file,
    uploading,
    handleUpload,
    handleCancelChangeAvatar,
    isChangingAvatar,
  } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleUploadClick = () => {
    if (isChangingAvatar) {
      inputRef.current?.click();
    }
  };

  return (
    <div className={'CHANGE__CONTROLS'}>
      <div className={'CHANGE__CONTROLS__INPUT'}>
        <ButtonComponent
          className={'Select__File__Button'}
          variant={'ghost'}
          onClick={handleUploadClick}
        >
          {file && isChangingAvatar ? file.name : 'Click to select'}
        </ButtonComponent>
        <input
          ref={isChangingAvatar ? inputRef : null}
          accept=".png, .jpg, .jpeg"
          aria-label="Select File to Upload"
          className={'Select__File'}
          style={{ display: 'none' }}
          type="file"
          onChange={handleFileChange}
        />
      </div>
      <div className={'AVATAR__Buttons__CONTAINER__Narrow__Mode'}>
        <ButtonComponent
          className="Preferences__Upload__AVATAR__Button"
          color="success"
          disabled={!touched || !isValid || !file || uploading}
          type="submit"
          variant="primary"
          onClick={handleUpload}
        >
          {BUTTON_LABELS.UPLOAD_AVATAR}
        </ButtonComponent>
        <ButtonComponent
          className="Preferences__Cancel__AVATAR__Button"
          color="success"
          disabled={uploading}
          variant="outline"
          onClick={handleCancelChangeAvatar}
        >
          {GLOBAL_CONSTANTS.CANCEL}
        </ButtonComponent>
      </div>
    </div>
  );
};

export default ChangeAvatar;
